import axios from 'axios';
import qs from 'qs';

const fetchPatrols = async (params) => axios.get(`/patrols`, { params });

const fetchPatrol = async (id) => axios.get(`/patrols/${id}`);

const deletePatrol = async (id) => axios.delete(`/patrols/${id}`);

const fetchFindings = async (id, params) =>
  axios.get(`/patrols/${id}/findings`, {
    params,
    paramsSerializer: (parameters) => qs.stringify(parameters, { arrayFormat: 'repeat' }),
  });

const fetchImages = async (id, params) => {
  const response = await axios.get(`/patrols/${id}/findings-images`, {
    params,
    paramsSerializer: (parameters) => qs.stringify(parameters, { arrayFormat: 'repeat' }),
  });
  if (response && response.data) return response.data;
  return response;
};

const downloadReport = async (id, params) =>
  axios.get(`/patrols/${id}/export`, {
    responseType: 'blob',
    params,
    paramsSerializer: (parameters) => qs.stringify(parameters, { arrayFormat: 'repeat' }),
  });

const uploadPatrol = async (request) => {
  const response = await axios.post(`/patrols/upload`, request);
  return response && response.data ? response.data : response;
};

const resyncPilot = async (id) => {
  const response = await axios.post(`/patrols/${id}/resync`);
  return response && response.data ? response.data : response;
};

const publishPatrol = async (id) => axios.patch(`/patrols/${id}/mark-as-published`);

const reviewPatrol = async (id) => axios.patch(`/patrols/${id}/mark-as-reviewed`);

const downloadErrorReport = async (id) => axios.get(`/patrols/${id}/error-report`, { responseType: 'blob' });

const getCoverage = async (id, isMissionShared) => {
  const response = await axios.get(`/patrols/${id}/coverage?isMissionShared=${isMissionShared}`);
  if (response && response.data && response.data.geometries) return response.data.geometries;
  return response;
};

const getHyperspectralCoverage = async (id, isMissionShared) => {
  const response = await axios.get(`/patrols/${id}/hyspex-coverage?isMissionShared=${isMissionShared}`);
  if (response && response.data && response.data.geometries) return response.data.geometries;
  return response;
};

const getUncoveredAreas = async (id, isMissionShared) => axios.get(`/patrols/${id}/uncovered-areas?isMissionShared=${isMissionShared}`);

export default {
  fetchFindings,
  fetchPatrols,
  fetchPatrol,
  deletePatrol,
  downloadReport,
  uploadPatrol,
  publishPatrol,
  reviewPatrol,
  downloadErrorReport,
  getCoverage,
  resyncPilot,
  getHyperspectralCoverage,
  getUncoveredAreas,
  fetchImages,
};
